import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';

const ID = '57';
const IABid = [25];

export const createPixel = (consentData?: string | null): HTMLIFrameElement => {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  if (consentData) {
    iframe.src = `https://pixel.advertising.com/ups/58164/sync?gdpr=1&gdpr_consent=${consentData}&_origin=1&redir=true`;
  } else {
    iframe.src =
      'https://pixel.advertising.com/ups/58164/sync?gdpr=0&gdpr_consent=&_origin=1&redir=true';
  }

  return iframe;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABid, () => {
    if (context.gdprConsent.consent?.gdprApplies) {
      const iframe = createPixel(context.gdprConsent.consent.tcString);
      fastdom.mutate(function userSyncOathCMPAddElement() {
        document.body.appendChild(iframe);
      });
    } else {
      const iframe = createPixel();
      fastdom.mutate(function userSyncOathAddElement() {
        document.body.appendChild(iframe);
      });
    }
  }),
);
